<template>
    <li class="BreadcrumbItem">
        <a v-if="!props.breadcrumb.isLast" :href="props.breadcrumb.url" class="BreadcrumbLink" @click.prevent="onClick">{{ props.breadcrumb.name }}</a>
        <span v-else class="BreadcrumbLink isLast">{{ props.breadcrumb.name }}</span>
    </li>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import  IBreadcrumb from '@app/interfaces/dtos/IBreadcrumb';

const emits = defineEmits(['clickLink']);
const props = defineProps({
    breadcrumb: {
        type: Object as PropType<IBreadcrumb>,
        required: true
    }
});

const onClick = () => {
    emits('clickLink', props.breadcrumb);
};
</script>

<style scoped lang="scss">
.BreadcrumbItem {
    display: flex;
    gap: 0.25rem;
    @include MarginAreas(0);
    @include PaddingAreas(0);
    .BreadcrumbLink {
        text-decoration: none;
        cursor: unset;
        color: $Grey-900;
        &:hover{
            text-decoration: underline;
        }
    }
    .isLast {
        &:hover {
            text-decoration: none;
        }
        white-space: pre;
    }
    &:not(:last-child) {
        overflow: hidden;
        white-space: nowrap;
        .BreadcrumbLink{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        cursor: pointer;
        &::after {
            font-family: 'icomoon';
            content: '\e93c';
            font-size: 9px;
        }
    }
}
</style>
